import { ArticleParagraph1, LinkButton, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NewbuildingBookingSuccessModal.css';

export interface INewbuildingBookingSuccessModalProps {
  confirmLink: string;
  onClose(): void;
  onConfirm(): void;
  open: boolean;
}

export const NewbuildingBookingSuccessModal: React.FC<INewbuildingBookingSuccessModalProps> = ({
  confirmLink,
  onClose,
  onConfirm,
  open,
}) => {
  return (
    <ModalWindow title="Запрос отправлен" width={452} open={open} onClose={onClose}>
      <div className={styles['container']}>
        <ArticleParagraph1>
          Перейдите на страницу партнёра Циан
          <br />и продолжите оформление заявки
        </ArticleParagraph1>

        <div className={styles['buttons-container']}>
          <div className={styles['button']}>
            <LinkButton
              href={confirmLink}
              onClick={onConfirm}
              rel="noopener noreferrer"
              size="XS"
              target="_blank"
              theme="fill_primary"
              type="button"
              fullWidth
            >
              Заполнить заявку
            </LinkButton>
          </div>
        </div>
      </div>
    </ModalWindow>
  );
};
